import "./navbar.css";

function Navbar() {

const user = JSON.parse(
localStorage.getItem("user")
);

return (

<div className="navbar">

<div>

<h3>Welcome Back</h3>

<p>
Manage your communication platform
</p>

</div>

<div className="profile-box">

<div className="avatar">

{user?.role?.charAt(0)}

</div>

</div>

</div>

)

}

export default Navbar;